export const tr = {
    'create-group-error': 'Grup oluşturulurken hata oluştu',
    'geo-empty-regions': 'Gösterim bölgeleri seçilmelidir',
    'warning-about-changes': 'Değişiklikleriniz kaydedilmeyecek. Devam etmek istiyor musunuz?',
    'warning-about-changes-internal':
        'Kaydedilmemiş gruplarınız var. Değişiklikler kaydedilmeden çıkmak istiyor musunuz?',
    'warning-about-empty-retargeting-conditions':
        'Seçilen bölgede tüm kullanıcıları hedefleyen grubu kaydetmek üzeresiniz. Devam etmek istiyor musunuz?'
};
